import { Controller } from "@hotwired/stimulus"
import { FrameRenderer } from "@hotwired/turbo"

export default class DependableFrameController extends Controller {
  renderFromDocument(doc) {
    const newElement = doc.querySelector(`turbo-frame#${this.element.id}`)

    FrameRenderer.renderElement(this.element, newElement)
  }
}
